// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".onfido-sdk-ui-DocumentAuto-DevTools-debugCanvas{margin-left:-22px;width:400px;height:250px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"debugCanvas": "onfido-sdk-ui-DocumentAuto-DevTools-debugCanvas"
};
export default ___CSS_LOADER_EXPORT___;
